
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductsDialog extends Serenity.EntityDialog<ProductsRow, any> {
        protected getFormKey() { return ProductsForm.formKey; }
        protected getIdProperty() { return ProductsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductsRow.localTextPrefix; }
        protected getNameProperty() { return ProductsRow.nameProperty; }
       /* protected getService() { return ProductsService.baseUrl; }*/
        protected getDeletePermission() { return ProductsRow.deletePermission; }
        protected getInsertPermission() { return ProductsRow.insertPermission; }
        protected getUpdatePermission() { return ProductsRow.updatePermission; }

        protected form = new ProductsForm(this.idPrefix);

        private productSpecificationsGrid1: ProductSpecificationsGrid1;
        private productPendrivesGrid1: ProductPendrivesGrid1;
        private productBookGrid1: ProductBooksGrid1;
        private productBillingItemsGrid1: ProductBillingItemsGrid1;
        private productBillingItemSpecificationGrid: ProductBillingItemSpecificationsGrid;

        
        private loadedState: string;

        constructor() {
            super();

            this.productSpecificationsGrid1 = new ProductSpecificationsGrid1(this.byId("ProductSpecificationsGrid"));
            this.productSpecificationsGrid1.element.flexHeightOnly(1);

            this.productPendrivesGrid1 = new ProductPendrivesGrid1(this.byId("ProductPendrivesGrid1"));
            this.productPendrivesGrid1.element.flexHeightOnly(1);

            this.productBookGrid1 = new ProductBooksGrid1(this.byId("ProductBooksGrid1"));
            this.productBookGrid1.element.flexHeightOnly(1);


            this.productBillingItemsGrid1 = new ProductBillingItemsGrid1(this.byId("ProductBillingItemsGrid1"));
            this.productBillingItemsGrid1.element.flexHeightOnly(1);

            this.productBillingItemSpecificationGrid = new ProductBillingItemSpecificationsGrid(this.byId("ProductBillingItemSpecificationsGrid"));
            this.productBillingItemSpecificationGrid.element.flexHeightOnly(1);

         


            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
            this.tabs.on('tabsactivate', (e, i) => { this.arrange() });

            this.form.EValidityType.changeSelect2(e => {
                var vValidityType = this.form.EValidityType.value;

                if (Q.isEmptyOrNull(vValidityType)) {
                    // this.setProductDetails({});
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);
                   
                }
                else {

                    if (vValidityType == '1' || vValidityType == '2') {

                        if (vValidityType == '2') {
                            this.form.ValidTill.getGridField().toggle(false);
                            this.form.EValidity.getGridField().toggle(true);
                            }
                        else {
                            this.form.ValidTill.getGridField().toggle(true);
                            this.form.EValidity.getGridField().toggle(false);
                            }
                    }

                }

            });

            this.form.AllowSerialKeyGeneration.changeSelect2(e => {
                if (this.form.AllowSerialKeyGeneration.value == true) {
                    Serenity.EditorUtils.setRequired(this.form.Rioplay8ProductCode, true);
                    Serenity.EditorUtils.setRequired(this.form.Rioplay8ESubscriptionType, true);
                    Serenity.EditorUtils.setRequired(this.form.Rioplay8EViewsType, true);
                    Serenity.EditorUtils.setRequired(this.form.Rioplay8EWatchTimetype, true);
                    Serenity.EditorUtils.setRequired(this.form.Rioplay8AllowedDevice, true);
                    Serenity.EditorUtils.setRequired(this.form.Rioplay8EDeviceRestrictionType, true);
                 /*   Serenity.EditorUtils.setRequired(this.form.Rioplay8SwitchCount, true);*/
                    Serenity.EditorUtils.setRequired(this.form.Rioplay8TenantId, true);
                    Serenity.EditorUtils.setRequired(this.form.TotalAllowedDuration, true);
                    Serenity.EditorUtils.setRequired(this.form.Secretkey, true);
                    Serenity.EditorUtils.setRequired(this.form.Rioplay8AllowedDevice, true);
                }
            });

            this.form.ERioplayVersion.changeSelect2(e => {
                var eRioplayVersion = this.form.ERioplayVersion.value;
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                if (eRioplayVersion != '4') {
                    this.form.EOpens.getGridField().toggle(true);
                    this.form.EWatchTime.getGridField().toggle(true);
                    this.form.EValidityType.getGridField().toggle(true);
                    this.form.Rioplay8ProductCode.getGridField().toggle(false);
                    this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                    this.form.Rioplay8EViewsType.getGridField().toggle(false);
                    this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                    this.form.Rioplay8WatchTime.getGridField().toggle(false);
                    this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(false);
                    this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                    this.form.Rioplay8SwitchCount.getGridField().toggle(false);
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                    this.form.Rioplay8ValidDate.getGridField().toggle(false);
                    this.form.RioPlayTenantId.getGridField().toggle(true);
                    this.form.Rioplay8TenantId.getGridField().toggle(false);
                    this.form.Rioplay8AllowedDevice.getGridField().toggle(false);

                }
                else {
                    this.form.EOpens.getGridField().toggle(true);
                    this.form.EWatchTime.getGridField().toggle(true);
                    this.form.EValidityType.getGridField().toggle(true);
                    this.form.EValidity.getGridField().toggle(true);
                    this.form.ValidTill.getGridField().toggle(true);
                    this.form.AllowedDevice.getGridField().toggle(true);
                    if (eRioplayVersion == '4') {
                        this.form.Rioplay8ProductCode.getGridField().toggle(true);
                        this.form.Rioplay8ESubscriptionType.getGridField().toggle(true);
                        this.form.Rioplay8EViewsType.getGridField().toggle(true);
                        this.form.Rioplay8EWatchTimetype.getGridField().toggle(true);
                        this.form.Rioplay8AllowedDevice.getGridField().toggle(true);
                        this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(true);
                        this.form.Rioplay8SwitchCount.getGridField().toggle(true);
                        this.form.Rioplay8TenantId.getGridField().toggle(true);
                        this.form.EOpens.getGridField().toggle(false);
                        this.form.EWatchTime.getGridField().toggle(false);
                        this.form.EValidityType.getGridField().toggle(false);
                        this.form.EValidity.getGridField().toggle(false);
                        this.form.ValidTill.getGridField().toggle(false);
                        this.form.AllowedDevice.getGridField().toggle(false);
                        this.form.RioPlayTenantId.getGridField().toggle(false);
                        this.form.RioplayProductCode.getGridField().toggle(false);
                    }
                    else {
                        this.form.EOpens.getGridField().toggle(true);
                        this.form.EWatchTime.getGridField().toggle(true);
                        this.form.EValidityType.getGridField().toggle(true);
                        this.form.EValidity.getGridField().toggle(true);
                        this.form.ValidTill.getGridField().toggle(true);
                        this.form.AllowedDevice.getGridField().toggle(true);
                        this.form.Rioplay8ProductCode.getGridField().toggle(false);
                        this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                        this.form.Rioplay8EViewsType.getGridField().toggle(false);
                        this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                        this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                        this.form.Rioplay8WatchTime.getGridField().toggle(false);
                        this.form.Rioplay8AllowedDevice.getGridField().toggle(false);
                        this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(false);
                        this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                        this.form.Rioplay8SwitchCount.getGridField().toggle(false);
                        this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                        this.form.Rioplay8ValidDate.getGridField().toggle(false);
                    }
                }
            });

            this.form.Rioplay8EViewsType.changeSelect2(e => {
                var eRioplay8EViewsType = this.form.Rioplay8EViewsType.value;
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                if (eRioplay8EViewsType == '1') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(true);
                }
                else if (eRioplay8EViewsType == '0') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                }
            });
            this.form.Rioplay8EWatchTimetype.changeSelect2(e => {
                var eRioplay8EWatchTimetype = this.form.Rioplay8EWatchTimetype.value;
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                if (eRioplay8EWatchTimetype == '1') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(true);
                }
                else if (eRioplay8EWatchTimetype == '0') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(false);
                }
            });
            this.form.Rioplay8ESubscriptionType.changeSelect2(e => {
                var eRioplay8ESubscriptionType = this.form.Rioplay8ESubscriptionType.value;
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                if (eRioplay8ESubscriptionType == '0') {
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(true);
                }
                else if (eRioplay8ESubscriptionType == '1')
                {
                    this.form.Rioplay8ValidDate.getGridField().toggle(true);
                }
            });
            this.form.Rioplay8EDeviceRestrictionType.changeSelect2(e => {
                var eRioplay8EDeviceRestrictionType = this.form.Rioplay8EDeviceRestrictionType.value;
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                if (eRioplay8EDeviceRestrictionType == '0') {
                    this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                }
                else if (eRioplay8EDeviceRestrictionType == '1')
                {
                    this.form.Rioplay8DeviceCount.getGridField().toggle(true);
                }
            });
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductSpecifications', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductPendrives', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBooks', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItems', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItemSpecifications', this.isNewOrDeleted());

            
            this.loadedState = this.getSaveState();
        }

        loadEntity(entity: ProductsRow) {
            super.loadEntity(entity);

            if (this.isNew()) {
                this.form.ValidTill.getGridField().toggle(false);
                this.form.EValidity.getGridField().toggle(false);
                this.form.Rioplay8ProductCode.getGridField().toggle(false);
                this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                this.form.Rioplay8EViewsType.getGridField().toggle(false);
                this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                this.form.Rioplay8AllowedDevice.getGridField().toggle(false);
                this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(false);
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                this.form.Rioplay8SwitchCount.getGridField().toggle(false);
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                this.form.Rioplay8TenantId.getGridField().toggle(false);
            }
            else if (this.isEditMode())
            {
                this.form.ValidTill.getGridField().toggle(false);
                this.form.EValidity.getGridField().toggle(false);
                this.form.Rioplay8ProductCode.getGridField().toggle(false);
                this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                this.form.Rioplay8EViewsType.getGridField().toggle(false);
                this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                this.form.Rioplay8AllowedDevice.getGridField().toggle(false);
                this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(false);
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                this.form.Rioplay8SwitchCount.getGridField().toggle(false);
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                this.form.Rioplay8TenantId.getGridField().toggle(false);
                var eRioplayversion = this.form.ERioplayVersion.value;
                if (eRioplayversion == '4')
                {
                    this.form.Rioplay8ProductCode.getGridField().toggle(true);
                    this.form.Rioplay8ESubscriptionType.getGridField().toggle(true);
                    this.form.Rioplay8EViewsType.getGridField().toggle(true);
                    this.form.Rioplay8EWatchTimetype.getGridField().toggle(true);
                    this.form.Rioplay8AllowedDevice.getGridField().toggle(true);
                    this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(true);
                    this.form.Rioplay8SwitchCount.getGridField().toggle(true);
                    this.form.Rioplay8TenantId.getGridField().toggle(true);
                    this.form.EOpens.getGridField().toggle(false);
                    this.form.EWatchTime.getGridField().toggle(false);
                    this.form.EValidityType.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.AllowedDevice.getGridField().toggle(false);
                    this.form.RioPlayTenantId.getGridField().toggle(false);
                    this.form.RioplayProductCode.getGridField().toggle(false);
                }
                var eRioplay8EViewsType = this.form.Rioplay8EViewsType.value;
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                if (eRioplay8EViewsType == '1') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(true);
                }
                else if (eRioplay8EViewsType == '0') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                }
                var eRioplay8EWatchTimetype = this.form.Rioplay8EWatchTimetype.value;
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                if (eRioplay8EWatchTimetype == '1') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(true);
                }
                else if (eRioplay8EWatchTimetype == '0') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(false);
                }
                var eRioplay8EDeviceRestrictionType = this.form.Rioplay8EDeviceRestrictionType.value;
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                if (eRioplay8EDeviceRestrictionType == '0') {
                    this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                }
                else if (eRioplay8EDeviceRestrictionType == '1') {
                    this.form.Rioplay8DeviceCount.getGridField().toggle(true);
                } var eRioplay8ESubscriptionType = this.form.Rioplay8ESubscriptionType.value;
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                if (eRioplay8ESubscriptionType == '0') {
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(true);
                }
                else if (eRioplay8ESubscriptionType == '1') {
                    this.form.Rioplay8ValidDate.getGridField().toggle(true);
                }
            }

            else {

                var vValidityType = this.form.EValidityType.value;

                if (Q.isEmptyOrNull(vValidityType)) {
                    // this.setProductDetails({});
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);

                }
                else {

                    if (vValidityType == '1' || vValidityType == '2') {

                        if (vValidityType == '2') {
                            this.form.ValidTill.getGridField().toggle(false);
                            this.form.EValidity.getGridField().toggle(true);
                        }
                        else {
                            this.form.ValidTill.getGridField().toggle(true);
                            this.form.EValidity.getGridField().toggle(false);
                        }
                    }

                }
            }

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductSpecifications', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductPendrives', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBooks', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItems', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductBillingItemSpecifications', this.isNewOrDeleted());

            this.productSpecificationsGrid1.ProductId = entity.Id;
            this.productPendrivesGrid1.ProductId = entity.Id;
            this.productBookGrid1.ProductId = entity.Id;
            this.productBillingItemsGrid1.ProductId = entity.Id;
            this.productBillingItemSpecificationGrid.ProductId = this.entityId;
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.productSpecificationsGrid1.ProductId = this.entityId;
            this.productPendrivesGrid1.ProductId = this.entityId;
            this.productBookGrid1.ProductId = this.entityId;
            this.productBillingItemsGrid1.ProductId = this.entityId;
            this.productBillingItemSpecificationGrid.ProductId = this.entityId;

            //Passing discount to OrderProduct Editor
            //   this.form.OrderProducts.discount = this.form.DiscountPer.value;
        }

        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            //if (this.form.OrderProducts.rowCount() == 0) {
            //    Q.alert("At least one Product is mandatory for Order.");
            //    return false;
            //}
            return isValidate;
        }

        protected updateInterface() {

            // by default cloneButton is hidden in base UpdateInterface method
            super.updateInterface();

            // here we show it if it is edit mode (not new)
            this.cloneButton.toggle(this.isEditMode());
        }

        /**
         * Overriding this method is optional to customize cloned entity
         */
        protected getCloningEntity() {
            var clone = super.getCloningEntity();

            // add (Clone) suffix if it's not already added
            //var suffix = ' (Clone)';
            //if (!Q.endsWith(clone.ProductName || '', suffix)) {
            //    clone.ProductName = (clone.ProductName || '') + suffix;
            //}

            // it's better to clear image for this sample
            // otherwise we would have to create a temporary copy of it
            // and upload
           
            return clone;
        }
    }
}